<template>
    <section v-show="item.selected">
        <p v-if="item.object.type.id === 10"><b>Номер:</b> <a :href="'https://pkk.rosreestr.ru/#/search?opened=' + item.object.id +'&text=' + item.object.id + '&type=' + item.object.type.id" target="_blank" title="План ЗОУИТ">{{item.object.id | fallback}}</a></p>
        <p v-else><b>Кадастровый номер:</b> <a :href="'https://pkk.rosreestr.ru/#/search?opened=' + item.object.id+ '&text=' + item.object.id + '&type=' + item.object.type.id" target="_blank" title="План ЗУ">{{item.object.cn | fallback}}</a></p>
        <p><b>Тип:</b> {{item.object.type.name | fallback}}</p>
        <p v-if="item.object.address"><b>Наименование:</b> {{item.object.address}}</p>
        <p v-if="item.object.cdzone"><b>Тип:</b> {{item.object.cdzone | cdzone}}</p>
        <p v-if="item.object.desc"><b>Описание:</b> {{item.object.desc}}</p>
        <p v-if="item.object.content_restrictions"><b>Ограничение:</b> {{item.object.content_restrictions}}</p>
        <p v-if="item.object.json_documents"><b>Основание:</b> {{item.object.json_documents | documents}}</p>

        <div class="map-result-hint" v-if="item.status == 'loading'">Идет уточнение координат участка...<div class="loader"></div></div>
        <div class="map-result-hint" v-if="item.status == 'nogeo'">Границы участка отсутствуют в кадастровой карте</div></div>
        <div class="map-result-hint" v-if="item.status == 'onlybbox'">Невозможно уточнить координаты, так как участок имеет слишком большую площадь. На карту нанесен ограничивающий прямоугольник участка. Для просмотра границ перейдите на сайт ПКК</div></div>
        <div class="map-result-hint map-result-failed" v-if="item.status == 'failed'">Не удалось получить координаты участка. Возможно, сервисы Росреестра недоступны или не могут обработать запрос</div></div>
    </section>
</template>

<script>
    import _ from 'lodash'
    import Rosreestr from '../Rosreestr'

    export default {
        props: ['item'],
        filters: {
            cdzone: function(type) {
                return _.get(Rosreestr.ZoneTypes, type) || type;
            },

            documents: function(json_documents) {
                return _.map(json_documents, doc => `${doc.name} №${doc.number} от ${doc.date}`).join(', ');
            }
        }
    }
</script>

<style scoped></style>


// WEBPACK FOOTER //
// RosreestrShape.vue?680fbfa6